import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiCheckCircle, FiArrowRight } from "react-icons/fi";

function HomeCTA() {
    return (
        <section data-theme="guardhartDark" className="relative py-24 bg-base-200 border-b border-zinc-800 overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div className="text-center lg:text-left">
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-base-content mb-6">
                            Ready to secure your assets?
                        </h2>
                        <p className="text-base text-zinc-400 mb-8 max-w-lg mx-auto lg:mx-0 leading-relaxed">
                            Get a comprehensive security audit from our ISO-certified team. We'll identify vulnerabilities and deliver a tailored protection plan.
                        </p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 max-w-lg mx-auto lg:mx-0">
                            <div className="flex items-center gap-3 text-left">
                                <FiCheckCircle className="w-5 h-5 text-primary shrink-0" />
                                <span className="text-sm text-zinc-300">Free initial consultation</span>
                            </div>
                            <div className="flex items-center gap-3 text-left">
                                <FiCheckCircle className="w-5 h-5 text-primary shrink-0" />
                                <span className="text-sm text-zinc-300">24hr response guarantee</span>
                            </div>
                            <div className="flex items-center gap-3 text-left">
                                <FiCheckCircle className="w-5 h-5 text-primary shrink-0" />
                                <span className="text-sm text-zinc-300">PSRA & ISO certified</span>
                            </div>
                            <div className="flex items-center gap-3 text-left">
                                <FiCheckCircle className="w-5 h-5 text-primary shrink-0" />
                                <span className="text-sm text-zinc-300">Custom protection plans</span>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <Link
                                to="/contact"
                                className="inline-flex items-center justify-center gap-2 bg-primary text-primary-content px-8 py-4 text-xs font-bold uppercase tracking-widest rounded active:scale-95 transition-all hover:brightness-110"
                            >
                                Request Security Audit
                                <FiArrowRight className="w-4 h-4" />
                            </Link>
                            <Link
                                to="/services"
                                className="inline-flex items-center justify-center gap-2 border border-zinc-700 text-zinc-100 px-8 py-4 text-xs font-bold uppercase tracking-widest rounded active:scale-95 transition-all hover:bg-zinc-800 hover:border-zinc-600"
                            >
                                Our Services
                            </Link>
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <div className="relative">
                            <div className="absolute inset-0 bg-primary/5 rounded-full blur-3xl" />

                            <div className="relative size-64 rounded-full border-[16px] border-zinc-200 flex items-center justify-center">
                                <FiShield className="text-[100px] text-primary/20" />
                            </div>
                            <div className="absolute -top-4 -right-4 bg-base-100 border border-zinc-200 rounded-lg px-4 py-2 shadow-lg">
                                <span className="text-xs font-bold text-primary">Fully Ensured</span>
                            </div>
                            <div className="absolute -bottom-4 -left-4 bg-base-100 border border-zinc-200 rounded-lg px-4 py-2 shadow-lg">
                                <span className="text-xs font-bold text-primary">PSRA Licensed</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default HomeCTA;